(function modalBackground(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const previousModalBackground = global.NewHomeSource.ModalBackground;

  /**
  * @constructs NewHomeSource.ModalBackground
  */
  function ModalBackground() {
  }

  /**
  * @public
  * createBackground: creates a modal background.
  * 
  * @param {string} backgroundColor background color of the overlay.
  */
  ModalBackground.createBackground = function createBackground(backgroundColor, zIndex) {
    const element = document.createElement('div');

    element.style['background-color'] = backgroundColor || 'rgba(0,0,0,.5)';
    element.style['z-index'] = zIndex || 100000;
    element.style.position = 'fixed';
    element.style.top = 0;
    element.style.left = 0;
    element.style.width = '100%';
    element.style.height = '100%';
    element.setAttribute('data-modal-background', '');
    document.body.appendChild(element);
    this.background = element;
    global.document.body.style.overflow = 'hidden';
  };

  /**
  * @public
  * destroyBackground: destroys a modal background.
  */
  ModalBackground.destroyBackground = function destroyBackground() {
    if (!this.background) {
      return;
    }

    global.document.body.style.overflow = '';
    this.background.parentElement.removeChild(this.background);
  };

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.ModalBackground to the previous script.
  */
  ModalBackground.noConflict = function noConflict() {
    global.NewHomeSource.ModalBackground = previousModalBackground;
    return ModalBackground;
  };

  global.NewHomeSource.ModalBackground = ModalBackground;
}(window));
